







































import {Component, Prop, Vue} from 'vue-property-decorator'
import {Helper} from 'simpli-web-sdk'
import ModalUpdateExpiringDate from '@/components/modals/ModalUpdateExpiringDate.vue'
import ModalUpdateActive from '@/components/modals/ModalUpdateActive.vue'
import {PanelUser} from '@/model/resource/PanelUser'
import ModalUpdateExpiringDateIntenational from '@/components/modals/ModalUpdateExpiringDateIntenational.vue'
import ModalUpdateActiveInternacional from '@/components/modals/ModalUpdateActiveInternacional.vue'

@Component({
  components: {
    ModalUpdateActiveInternacional,
    ModalUpdateExpiringDateIntenational,
  },
})
export default class PopoverPanelUser extends Vue {
  @Prop({type: Object, required: true}) panelUser!: PanelUser
  @Prop({type: [String, Number], default: null}) index!: string | number | null

  get name() {
    if (this.index !== null) {
      return `panelUser${this.index}`
    }
    return 'panelUser'
  }

  clickOutside() {
    this.$tip.hideAll()
  }

  async allowPanelUser() {
    await this.panelUser.updateActive(true)
    await Helper.success('system.success.persist')
    window.location.reload()
    this.clickOutside()
  }

  hideEvent() {
    this.$emit('hide')
  }

  showEvent() {
    this.$emit('show')
  }

  goToEditPage() {
    Helper.pushByName('editResponsavelInternacional', this.panelUser.$id)
  }

  async openModalDataVencimento() {
    this.$modal.open('updateExpiringDateInternational', this.panelUser.$id)
  }

  async openModalBlockPanelUser() {
    this.$modal.open('updateActiveInternational', this.panelUser.$id)
  }

  async softBlock() {
    // await this.panelUser.removePanelUser()
    await Helper.success('system.success.persist')
    window.location.reload()
    this.clickOutside()
  }

  getPositionByIndex() {
    const listIndex = 10
    return this.index && this.index >= listIndex ? 'top' : 'bottom'
  }
}
